import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMainContext } from "../Context";

const AuthLayout = ({ children }) => {
  const { isLogin } = useMainContext();
  const navigate = useNavigate();

  let loc = useLocation()
  useEffect(() => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(loc.pathname)
    }
  }, [loc])

  if (isLogin()) {
    window.location.replace("/");

    return;
  } else {
    return <>{children}</>;
  }
};

export default AuthLayout;
